/**
 * Checks if a translation exists for a given index
 * @param baseKey - The base translation key without the index (e.g., "testType:Step1Screen:text")
 * @param i - The index to append to the base key
 * @param t - The translation function
 * @returns true if translation exists, false otherwise
 */
export const checkTranslationExists = (
  baseKey: string,
  i: number,
  t: (key: string, options?: { returnObjects?: boolean }) => string
): boolean => {
  const translationKey = `${baseKey}${i}`;
  const translatedText = t(translationKey, { returnObjects: false });
  // If translation returns the key itself, it means the key doesn't exist
  const exists = translatedText !== translationKey;
  return exists;
};

